import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { Grid } from '@material-ui/core';
import styles from "../../screens/team/team.module.css";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    height: 200,
    bgcolor: 'background.paper',
    borderRadius: '5px',
    pt: 4,
    pb: 3,
    px: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center'
};

export default function LogOutModal(props) {
    const { setOpen, open, handleLogout } = props

    return (
        <div>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Grid container justifyContent="center">
                        <Grid item md={12} style={{ display: "flex", justifyContent: "center", marginTop: "2px" }}>
                            <p className={styles.logOutModelText}>Are you sure you want to log out of your account?</p>
                        </Grid>
                    </Grid>
                    <Grid container justifyContent="center">
                        <Grid container item md={8}>
                            <Grid item md={6} style={{ display: "flex", justifyContent: "center" }}>
                                <Button
                                    fullWidth
                                    size='large'
                                    onClick={() => handleLogout()}
                                    style={{
                                        fontSize: '0.9rem',
                                        lineHeight: '1.25rem',
                                        fontFamily: 'Poppins',
                                        fontWeight: 500,
                                        fontStyle: 'normal',
                                        width: 150,
                                        height: 50,
                                        backgroundColor: "white",
                                        color: "#0F9BB0",
                                        textTransform: "none",
                                        border: "2px solid",
                                        borderColor: "#0F9BB0"
                                    }}
                                >
                                    Yes, log out
                                </Button>
                            </Grid>
                            <Grid item md={6} style={{ display: "flex", justifyContent: "center" }}>
                                <Button
                                    fullWidth
                                    size='large'
                                    onClick={() => setOpen(false)}
                                    style={{
                                        fontSize: '0.9rem',
                                        lineHeight: '1.25rem',
                                        fontFamily: 'Poppins',
                                        fontWeight: 500,
                                        fontStyle: 'normal',
                                        width: 150,
                                        height: 50,
                                        backgroundColor: "#0F9BB0",
                                        color: "white",
                                        textTransform: "none",
                                    }}
                                >
                                    No, stay here
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </div>
    );
}